module.exports = __webpack_public_path__ + "img/intercom-on.0cd54954.png";